<div
  #modalContents
  [class]="lmodalContentsClassWithWidth"
  aria-modal="true"
  role="dialog"
  aria-labelledby="(モーダルのタイトル)"
>
  <div #modalHead [class]="lmodalHeaderClass">
    （モーダルのヘッダ部分のHTML）
    <button class="button-test" id="testClose" (click)="close()">モーダルを閉じる</button>
  </div>

  <div #modalBody [class]="lmodalBodyClass">
    <div [class]="styleClass">
      <div>（モーダルのメイン部分のHTML）</div>
      <div>クラス設定:{{ lmodalContentsClassWithWidth }}</div>
      <div>縦サイズ変更ボタン</div>
      <button class="button-test" id="test1" (click)="test1()">300px</button>
      <button class="button-test" id="test2" (click)="test2()">600px</button>
      <button class="button-test" id="test3" (click)="test3()">900px</button>
      <button class="button-test" id="test4" (click)="test4()">1200px</button>
      <button class="button-test" id="test5" (click)="test5()">1500px</button>
      <button class="button-test" id="testScroll" (click)="goScrollPoint()">スクロール位置移動</button>
    </div>
    <div id="scroll-point">スクロール位置</div>
    <div [class]="styleClass"></div>
  </div>

  <div #modalFooter [class]="lmodalFooterClass">(モーダルのフッタ部分のHTML）</div>
</div>
